// extracted by mini-css-extract-plugin
export default {"root":"Content_root__ovsJ5","container":"Content_container__5Ta82","center":"Content_center__rSR5P"};